import React, {Fragment} from 'react'
import {Route} from "react-router";
import {AccountInfo } from '@azure/msal-browser';
import {
    Client as GraphClient,
} from "@microsoft/microsoft-graph-client";


import Shortcutter from "../Shortcutter";
import ApiService from "../ApiService";
import {MessageBarHelper} from "../../utils/MessageBarHelper";
import {UserAccessLevel} from "../../models/UserAccessRecord";
import {SchoolsCanAccessResponse} from "../../models/SchoolsCanAccessResponse";
import SchoolAccessCheck from "./SchoolAccessCheck";
import {SchoolAccessLevel} from "../../models/SchoolAccessRecord";
import SignedInCheck from "./SignedInCheck";

interface AuthorizeRouteProps {
    path: string,
    exact: boolean;
    component: React.ElementType,
    user: AccountInfo | undefined,
    userIsCdbEmployee: boolean;
    usersCdbAccessLevel: UserAccessLevel | undefined;
    minSchoolAccessLevel: SchoolAccessLevel | "tenantManager" | undefined;
    schoolsCanAccess: SchoolsCanAccessResponse | undefined;
    apiService: ApiService;
    graphClient: GraphClient;
    messageBar: MessageBarHelper;
    signIn: () => void;
}


export default function AuthorizeRoute(props: AuthorizeRouteProps)
{
    return (
        <Route path={props.path} exact={props.exact} render={(routerProps) => 
        {
            return (
                <Fragment>
                    <SignedInCheck user={props.user} signIn={props.signIn}>
                        {() => {
                            return (
                                <SchoolAccessCheck userIsCdbEmployee={props.userIsCdbEmployee} tenantId={routerProps.match.params.tenantId} schoolCode={routerProps.match.params.schoolCode} schoolsCanAccess={props.schoolsCanAccess} minSchoolAccessLevel={props.minSchoolAccessLevel} messageBarHelper={props.messageBar} history={routerProps.history}>
                                    {() => {

                                        let Component = props.component;
                                        return (
                                            /* assume component page's props is implementing ICDBPageProps */
                                            <Component {...props} {...routerProps} {...routerProps.match.params}
                                                       apiService={props.apiService}
                                                       messageBar={props.messageBar}
                                                       graphClient={props.graphClient}
                                                       usersCdbAccessLevel={props.usersCdbAccessLevel}/>
                                        );
                                    }}
                                </SchoolAccessCheck>
                            );
                        }}
                    </SignedInCheck>
              
                    {props.userIsCdbEmployee ? <Shortcutter history={routerProps.history} match={routerProps.match}/> : null}
                </Fragment>
            );
        }} />
    );
}